import * as Sentry from '@sentry/browser'

/**
 * convert error to an object for better readability in sentry
 * @param {Error|string} err
 * @returns {{string: string}|{}}
 * @private
 */
function errorToObj (err) {
  if (typeof err === 'string') {
    return {
      error: err
    }
  }

  return Object.getOwnPropertyNames(err).reduce((errorObj, key) => {
    errorObj[key] = err[key]

    return errorObj
  }, {})
}

/**
 * @param {Error|string} error
 * @param {object} extraData
 * @param {string} level
 */
export function logError (error, extraData = {}, level = Sentry.Severity.Error) {
  const errorObj = errorToObj(error)

  Sentry.withScope(scope => {
    scope.setExtra('error', errorObj)
    Object.keys(extraData).forEach(key => scope.setExtra(key, extraData[key]))

    Sentry.captureException(error.originalError || error.error || error)
  })

  if (process.env.NODE_ENV !== 'production') {
    /* eslint-disable-next-line no-console */
    console.log(error, extraData)
  }
}
